import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './styles.scss'

const bc = 'chart-title'

const ChartTitle = ({ t, currentDay, totalDays, proTrackNameWithLevelName }) => (
  <div className={bc}>
    <div className={`${bc}__protrack-title`}>{proTrackNameWithLevelName}</div>
    {t('progress-in-days', { currentDay, totalDays })}
  </div>
)

ChartTitle.propTypes = {
  currentDay: PropTypes.number.isRequired,
  totalDays: PropTypes.number.isRequired,
  proTrackNameWithLevelName: PropTypes.string.isRequired,
}

export default withTranslation('user')(ChartTitle)
